export type AspectRatio = "3:4" | "1:1" | "4:3"

export function aspectRatioToNumeric(ar: AspectRatio): number {
  const [w, h] = ar.split(":").map(Number)
  return w / h
}
